<template>
  <div class="classmodal_content">
    <a-row :gutter="20" style="display: flex; margin-bottom: 10px;" v-for="(courseDateItem, index) in courseDateList" :key="index">
      <a-col :span="22">
        <a-row style="display: flex;">
          <a-col :span="6" >
            <a-time-picker
              v-model="courseDateItem.startTime"
              placeholder="开始时间"
              format="HH:mm"
              :disabledHours="(value) => disabledStartHours(value, courseDateItem)"
              :disabledMinutes="(value) => disabledStartMinutes(value, courseDateItem)"
              @change="changeTimeList"
            />
          </a-col>
          <a-col :span="6" >
            <a-time-picker
              v-model="courseDateItem.endTime"
              placeholder="结束时间"
              format="HH:mm"
              :disabledHours="(value) => disabledEndHours(value, courseDateItem)"
              :disabledMinutes="(value) => disabledEndMinutes(value, courseDateItem)"
              @change="changeTimeList"
            />
          </a-col>
          <a-col :span="12" >
            <a-date-picker
              inputReadOnly
              :open="courseDateItem.showDate"
              :showToday="false"
              dropdownClassName="course_time_picker"
              @change="(value, dateString) => handleCourseTimeChange(value, dateString, index)"
              :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
            >
              <template slot="dateRender" slot-scope="current, today">
                <div
                  class="ant-calendar-date"
                  :style="getCurrentStyle(current, today, index)"
                >
                  {{ current.date() }}
                </div>
              </template>
              <template slot="renderExtraFooter">
                <div
                  style="
                    display: flex;
                    justify-content: flex-end;
                    padding: 5px 0;
                  "
                >
                  <a-button
                    type="danger"
                    size="small"
                    style="margin-right: 15px"
                    @click.stop.prevent="cleanDateArr(index)"
                  >
                    重置
                  </a-button>
                  <a-button
                    type="primary"
                    size="small"
                    @click.stop.prevent="
                      handleShowDatePickerChange(false, index)
                    "
                  >
                    确定
                  </a-button>
                </div>
              </template>

              <!-- 自定义日历选项start -->
              <div :class="[courseDateItem.showDate ? 'course_date_active' : '', 'course_date']"
                @click="handleShowDatePickerChange(true, index)"
              >
                <div class="tag_list">
                  <div class="course_date_tag"
                    v-for="dateTime in courseDateItem.dateArr"
                    :key="dateTime.index"
                  >
                    {{ moment(dateTime).format('YYYY-MM-DD') }}
                  </div>
                  <div
                    v-show="courseDateItem.dateArr.length == 0"
                    class="placeholder"
                  >
                    请选择授课日期
                  </div>
                </div>
                <div v-show="courseDateItem.dateArr.length > 3" class="ellipsis">...</div>
                <a-icon slot="suffix" type="calendar" />
              </div>
              <!-- 自定义日历选项end -->
            </a-date-picker>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="2" class="icon-container">
        <i :class="`icon-btn ${index > 0 ? 'icon-remove' : 'icon-add'}`" @click="handleChangeDateList(index > 0 ? 'remove' : 'add', index)"></i>
      </a-col>
    </a-row>

    <div class="error-tip" v-show="showError">请填写有效的授课时间</div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'CourseDate', // 巡视备注组件
  props: {
    showDateError: Boolean,
    showDialog: Boolean,
    item: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  components: {
  },
  watch: {
    showDateError(nVal) {
      this.showError = nVal
    }
  },
  data () {
    return {
      showError: false,
      courseDateList: [
        {
          startTime: '',
          endTime: '',
          dateArr: [],
          showDate: false,
        }
      ],
    }
  },
  methods: {
    moment,
    checkTime() {
      const lastItem = this.courseDateList[this.courseDateList.length-1]
      this.showError = !lastItem.startTime || !lastItem.endTime || !lastItem.dateArr.length
    },
    changeTimeList() {
      let timeList = []
      if (this.showError) this.checkTime()
      this.courseDateList.forEach(courseDateItem => {
        const { dateArr, startTime, endTime } = courseDateItem
        if (dateArr.length && startTime && endTime) {
          const list = dateArr.map(date => ({
            startDateTime: moment(date).format('YYYY-MM-DD') + ' ' + moment(startTime).format('HH:mm'),
            endDateTime: moment(date).format('YYYY-MM-DD') + ' ' + moment(endTime).format('HH:mm')
          }))
          timeList = [...timeList, ...list]
        }
      })
      this.$emit('changeTimeList', timeList)
    },
    handleChangeDateList(option, index) {
      if (option === 'add') {
        this.checkTime()
        if (this.showError) return
        this.courseDateList.push({ startTime: '', endTime: '', dateArr: [], showDate: false })
        return
      }
      if (option === 'remove') {
        this.courseDateList.splice(index, 1)
      }
    },
    cleanDateArr(index) {
      this.courseDateList[index].dateArr = []
    },
    handleShowDatePickerChange(showDate, index) {
      this.courseDateList.forEach((item) => {
        item.showDate = false
      })
      this.courseDateList[index].showDate = showDate
      if (!showDate) {
        this.changeTimeList()
      }
    },
    handleCourseTimeChange(value, dateString, index) {
      if (value == null) return
      // 没有日期就添加 有就删除
      let fIndex = this.courseDateList[index].dateArr?.findIndex(
        (item) => moment(item).valueOf() == moment(value).valueOf()
      )
      if (fIndex == -1) {
        this.courseDateList[index].dateArr?.push(value)
        this.courseDateList[index].dateArr?.sort((a, b) => {
          return moment(a).valueOf() - moment(b).valueOf()
        })
      } else {
        this.courseDateList[index].dateArr?.splice(fIndex, 1)
        if (this.courseDateList[index].dateArr.length == 0) {
        }
      }
    },
    getCurrentStyle(current, today, index) {
      const style = {}
      const dateArr = this.courseDateList[index].dateArr || []
      let dateArrDateArr = dateArr.map((item) => moment(item).format('MM-DD'))
      if (dateArrDateArr.includes(moment(current).format('MM-DD'))) {
        style.border = '1px solid transparent'
        style.color = '#fff'
        style.borderRadius = '2px'
        style.backgroundColor = '#1890ff'
      }
      return style
    },

    disabledStartHours(value, courseDateItem) {
      if(courseDateItem.endTime){
        let hours = [];
        let hour = moment(courseDateItem.endTime).hour();
        for (let i = hour+1; i < 24; i++) {
          hours.push(i);
        }
        return hours
      }
    },
    disabledStartMinutes(selectedHour, courseDateItem) {
      if(courseDateItem.endTime){
        let minutes = [];
        let hour = moment(courseDateItem.endTime).hour();
        let minute = moment(courseDateItem.endTime).minute();
        if(selectedHour===hour){
          for (let i = minute+1; i < 60; i++) {
            minutes.push(i);
          }
        }
        return minutes
      }
    },
    disabledEndHours(value, courseDateItem) {
      if(courseDateItem.startTime){
        let hours = [];
        let hour = moment(courseDateItem.startTime).hour();
        for (let i = 0; i < hour; i++) {
          hours.push(i);
        }
        return hours
      }
    },
    disabledEndMinutes(selectedHour, courseDateItem) {
      if(courseDateItem.startTime){
        let minutes = [];
        let hour = moment(courseDateItem.startTime).hour();
        let minute = moment(courseDateItem.startTime).minute();
        if(selectedHour===hour){
          for (let i = 0; i < minute; i++) {
            minutes.push(i);
          }
        }
        return minutes
      }
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .course_time_picker {
  top: -304px !important;
}
::v-deep .ant-calendar-input-wrap {
  display: none;
}

.classmodal_content {
  .error-tip{
    color: #f5222d;
  }
  .course_date_active {
    box-shadow: 0 0 2px #40a9ff;
    border-color: #1890ff !important;
    border-width: 1px;
  }
  .has-error {
    .course_date {
      box-shadow: 0 0 2px #f5222d;
      border-color: #f5222d !important;
      border-width: 1px;
    }
  }
  .course_date {
    position: relative;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    height: 32px;
    cursor: pointer;
    width: 285px;
    display: flex;
    align-items: center;
    &:focus {
      border-color: #40a9ff;
      border-right-width: 1px;
    }

    .tag_list {
      display: flex;
      align-items: center;
      overflow: hidden;
      width: 250px;
      .placeholder {
        margin-left: 10px;
        color: #bfbfbf;
      }
      .course_date_tag {
        font-size: 14px;
        background-color: #1890ff;
        color: #fff;
        border-radius: 4px;
        margin-left: 3px;
        padding: 0 3px;
        width: 80px;
        flex-shrink: 0;
        cursor: pointer;
      }
    }

    > i {
      position: absolute;
      right: 5px;
      cursor: pointer;
    }
  }
}
.icon-container{
  display: flex;
  align-items: center;
  .icon-btn {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;
    &:hover{
      opacity: 0.9;
    }
    &.icon-add{
      background-image: url('../../../../img/icon-add@2x.png');
    }
    &.icon-remove{
      background-image: url('../../../../img/icon-remove@2x.png');
    }
  }
}
</style>